"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
var _CetComponentsProvider = require("../../../../../providers/CetComponentsProvider");
const useStyles = props => {
  const {
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    themeColors
  } = (0, _react.useContext)(_CetComponentsProvider.CetComponentsContext);
  const {
    view = 'default'
  } = props;
  const ccItemTypesStyle = (0, _react.useMemo)(() => {
    const viewProps = () => {
      if (view === 'horizontal') {
        return {
          marginTop: pxToRem(6),
          marginBottom: pxToRem(25),
          position: 'relative',
          right: 0,
          left: 0,
          fontSize: pxToRem(13),
          lineHeight: pxToRem(14),
          color: '#686868',
          display: 'block'
        };
      }
      return {
        color: themeColors?.general.light,
        bottom: pxToRem(8),
        position: 'absolute',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flexStart'
      };
    };
    const ccItemTypes = (0, _css.css)({
      ...viewProps()
    });
    return {
      ccItemTypes
    };
  }, [pxToRem, themeColors?.general.light, view]);
  return {
    'cc-Item__types': ccItemTypesStyle.ccItemTypes
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;